export default __webpack_public_path__ + "static/media/postgresql.d00ff466.png";